import { useState } from 'react'
import { Download, Share, SquarePlus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  acceptInstallOffer,
  isAppleMobile,
  isRunningInstalled,
  useInstallOffer,
} from '@/src/lib/pwa'

/**
 * "Install Helm": puts Helm on the home screen, dock or start menu as its own
 * app. Shown only where installing is possible and Helm is not already
 * running installed.
 */
export function InstallHelm() {
  const offer = useInstallOffer()
  const [installed] = useState(isRunningInstalled)
  const [appleMobile] = useState(isAppleMobile)
  const [appleSteps, setAppleSteps] = useState(false)

  if (installed || (!offer && !appleMobile)) return null

  return (
    <>
      <Button
        variant="ghost"
        className="w-full justify-start"
        onClick={() => (offer ? void acceptInstallOffer() : setAppleSteps(true))}
      >
        <Download className="mr-2 h-4 w-4" />
        Install Helm
      </Button>
      <Dialog open={appleSteps} onOpenChange={setAppleSteps}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Install Helm on this device</DialogTitle>
            <DialogDescription>
              Helm then opens from its own icon on your home screen, full screen.
            </DialogDescription>
          </DialogHeader>
          <ol className="space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <span className="font-medium">1.</span> Tap
              <Share className="size-4" aria-label="Share" /> in the browser toolbar.
            </li>
            <li className="flex items-center gap-2">
              <span className="font-medium">2.</span> Choose
              <SquarePlus className="size-4" aria-hidden="true" />
              <span className="font-medium">Add to Home Screen</span>.
            </li>
            <li className="flex items-center gap-2">
              <span className="font-medium">3.</span> Tap <span className="font-medium">Add</span>.
            </li>
          </ol>
        </DialogContent>
      </Dialog>
    </>
  )
}
